export var HUB_STUDIO_PREFIX_PATH = '/studio/s/:cloudId/hubs';
export var HUB_STUDIO_HUBS_HOME_NAME = 'Hub Studio - Home';
export var HUB_STUDIO_HUBS_HOME_PATH = "".concat(HUB_STUDIO_PREFIX_PATH);